<template>
  <div>
    <div class="row">
      <div class="col-12">
        <p class="text-justify">
          Estimado solicitante, con fecha {{ fecha }}, usted acaba de enviar una
          solicitud de afiliación al partido político {{ partidoSelecionado }}.
        </p>
        <p class="text-justify">
          La solicitud deberá ser previamente aprobada por el partido político
          de acuerdo con los requisitos establecidos en su estatuto interno y
          luego validada por Servel. Sin perjuicio de lo anterior, Ud. podrá
          desistirse de esta solicitud a través de las plataformas disponibles
          en nuestra página web o en cualquiera de nuestras Direcciones
          Regionales a lo largo del país, hasta antes de que el partido acepte
          su incorporación.
        </p>
        <!-- <p class="text-justify">
          Asimismo, se hace presente a Ud. que según lo dispuesto en el inciso
          final del artículo 19 de la Ley 18.603, si el partido político no se
          pronuncia sobre la solicitud dentro del plazo de cuarenta días hábiles
          desde que ésta se efectuó, el solicitante podrá requerir al Servicio
          Electoral que lo incorpore como afiliado o adherente al respectivo
          registro del partido, solicitud que deberá realizar presencialmente en
          cualquier Dirección Regional del país.
        </p> -->
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="alert alert-info" role="alert">
          <p class="text-justify">
            En virtud de lo dispuesto en el inciso final del artículo 19 de la
            Ley N° 18.603, Orgánica Constitucional de los Partidos Políticos,
            cuando la colectividad no se pronuncia sobre la solicitud en el
            plazo de 40 días hábiles desde su presentación, esta se entenderá
            aprobada por el partido político, pasando a revisión del Servicio
            Electoral que verificará el cumplimiento de los requisitos legales
            para incorporarse o no al Registro General de Afiliados. En caso de
            que cumpla los requisitos, su incorporación al Registro de Afiliados
            se realizará desde la fecha de la respectiva solicitud.
          </p>
        </div>
      </div>
    </div>
    <el-divider></el-divider>

    <template v-if="media.sm">
      <div class="row text-center">
        <div class="col">
          <el-button
            type="success"
            @click="endProcess"
            class="terminar"
            data-cy="affiliation-end"
          >
            Terminar
          </el-button>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="d-flex justify-content-end">
        <el-button
          type="success"
          @click="endProcess"
          class="terminar"
          data-cy="affiliation-end"
        >
          Terminar
        </el-button>
      </div>
    </template>
  </div>
</template>

<script>
import moment from "moment";
import ScreenSizeMixin from "@/mixins/ScreenSizeMixin";
import { RouterMixin } from "@/mixins/routerMixin";
import { Alert, Divider } from "element-ui";

export default {
  name: "AfiliacionExitosa",
  components: {
    [Divider.name]: Divider,
    [Alert.name]: Alert,
  },
  props: {
    partidoSelecionado: String,
  },
  mixins: [ScreenSizeMixin, RouterMixin],
  computed: {
    fecha: function () {
      return moment().format("DD-MM-YYYY");
    },
  },
  methods: {
    endProcess() {
      this.navigate({ name: "resumen-tramites" });
    },
  },
};
</script>
